import { render, staticRenderFns } from "./lessonEdit.vue?vue&type=template&id=c0b33e10&"
import script from "./lessonEdit.vue?vue&type=script&lang=js&"
export * from "./lessonEdit.vue?vue&type=script&lang=js&"
import style0 from "./lessonEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports